import { SkeletonCard, SkeletonText } from '@kainos/ui';

/** Route-level placeholder while a lazily loaded screen arrives. */
export function LoadingScreen() {
  return (
    <div className="animate-kainos-fade-in" aria-busy="true" aria-live="polite">
      <span className="sr-only">Cargando</span>
      <SkeletonText lines={2} className="mb-7 max-w-md" />
      <div className="mb-7 grid gap-3.5 sm:grid-cols-2 xl:grid-cols-3">
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
      </div>
      <SkeletonCard />
    </div>
  );
}
